/**
 * @flow
 * @relayHash 5ab2cf9a717801ff1cf4693cdc0964af
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EstimateContainer_node$ref = any;
export type UpdateEstimateLineItemInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  quantity?: ?number,
  price_cents?: ?number,
  price_currency?: ?string,
  position?: ?number,
  description?: ?string,
};
export type LineItems_updateEstimateLineItemMutationVariables = {|
  input: UpdateEstimateLineItemInput
|};
export type LineItems_updateEstimateLineItemMutationResponse = {|
  +updateEstimateLineItem: ?{|
    +estimate: ?{|
      +$fragmentRefs: EstimateContainer_node$ref
    |}
  |}
|};
export type LineItems_updateEstimateLineItemMutation = {|
  variables: LineItems_updateEstimateLineItemMutationVariables,
  response: LineItems_updateEstimateLineItemMutationResponse,
|};
*/


/*
mutation LineItems_updateEstimateLineItemMutation(
  $input: UpdateEstimateLineItemInput!
) {
  updateEstimateLineItem(input: $input) {
    estimate {
      ...EstimateContainer_node
      id
    }
  }
}

fragment EstimateContainer_node on Estimate {
  id
  title
  notes
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  hide_total
  estimate_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  estimate_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateLineItemInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateEstimateLineItemInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "LineItems_updateEstimateLineItemMutation",
  "id": null,
  "text": "mutation LineItems_updateEstimateLineItemMutation(\n  $input: UpdateEstimateLineItemInput!\n) {\n  updateEstimateLineItem(input: $input) {\n    estimate {\n      ...EstimateContainer_node\n      id\n    }\n  }\n}\n\nfragment EstimateContainer_node on Estimate {\n  id\n  title\n  notes\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  hide_total\n  estimate_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  estimate_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "LineItems_updateEstimateLineItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimateLineItemPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate",
            "storageKey": null,
            "args": null,
            "concreteType": "Estimate",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "EstimateContainer_node",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LineItems_updateEstimateLineItemMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimateLineItem",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimateLineItemPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate",
            "storageKey": null,
            "args": null,
            "concreteType": "Estimate",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_last_name",
                "args": null,
                "storageKey": null
              },
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "share_token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_logo_url",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_header",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_first_name",
                "args": null,
                "storageKey": null
              },
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_company_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_phone",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_address",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hide_total",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "estimate_event_segments",
                "storageKey": "estimate_event_segments(first:99999)",
                "args": v5,
                "concreteType": "EstimateEventSegmentConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EstimateEventSegmentEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EstimateEventSegment",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line1",
                            "args": null,
                            "storageKey": null
                          },
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "start_at",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "end_at",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "time_zone",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "all_day",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "location",
                            "args": null,
                            "storageKey": null
                          },
                          v4,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line2",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "city",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "province",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "postal_code",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "room",
                            "args": null,
                            "storageKey": null
                          },
                          v3,
                          v6
                        ]
                      },
                      v7
                    ]
                  },
                  v8
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "estimate_event_segments",
                "args": v5,
                "handle": "connection",
                "key": "EstimateContainer_estimate_event_segments",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "estimate_line_items",
                "storageKey": "estimate_line_items(first:99999)",
                "args": v5,
                "concreteType": "EstimateLineItemConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EstimateLineItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EstimateLineItem",
                        "plural": false,
                        "selections": [
                          v2,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "position",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "price_cents",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "price_currency",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quantity",
                            "args": null,
                            "storageKey": null
                          },
                          v4,
                          v6
                        ]
                      },
                      v7
                    ]
                  },
                  v8
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "estimate_line_items",
                "args": v5,
                "handle": "connection",
                "key": "EstimateContainer_estimate_line_items",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workspaces",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkspaceConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkspaceEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Workspace",
                        "plural": false,
                        "selections": [
                          v2,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "event",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Event",
                            "plural": false,
                            "selections": [
                              v2,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "user_contacts",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "EventUserContactConnectionWithRole",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EventUserContactEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "UserContact",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "first_name",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "last_name",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user_contact_emails",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserContactEmailConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "edges",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "UserContactEmailEdge",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "UserContactEmail",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "address",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      v2
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          v2
                                        ]
                                      },
                                      v2
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7938569013266410b44ca561eceec4ae';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Estimate/__generated__/LineItems_updateEstimateLineItemMutation.graphql.js